module.exports = __webpack_public_path__ + "static/media/market_star.bc01bdec.svg";